import { getCombinableLiveBets, getCombinablePrematchBets } from './betExclusionValidations';
import { indexOrderedBetsByMarket } from '../turboLive/push/detail/handlers';
import { isProfileCombinableBetsEnabled } from '../../profiles';

export const computeCombinableBets = () => db => {
    if (!isProfileCombinableBetsEnabled()) {
        return db;
    }

    const isLiveDetailOpened = db.getIn(['turboLive', 'detail', 'isLive']);
    const isPrematchDetailOpened = db.getIn(['turboLive', 'detail', 'isPrematch']);

    if (!isLiveDetailOpened && !isPrematchDetailOpened) {
        return db;
    }

    if (isLiveDetailOpened) {
        const bets = db.getIn(['turboLive', 'detail', 'bets']);
        const markets = db.getIn(['turboLive', 'detail', 'markets']);
        const allowMarketCombinations = db.getIn(['turboLive', 'detail', 'combinableBetIdsByMarket']);
        const matchId = db.getIn(['turboLive', 'detail', 'matchId']);
        const jsBets = bets
            ?.map(bet => bet.toJS())
            .toIndexedSeq()
            .toArray();
        const jsMarkets = markets
            ?.map(market => market.toJS())
            .toIndexedSeq()
            .toArray();
        const combinableBets = getCombinableLiveBets(jsBets, jsMarkets, allowMarketCombinations, matchId);

        return db.setIn(['turboLive', 'detail', 'combinableBetIdsByMarket'], indexOrderedBetsByMarket(combinableBets));
    } else if (isPrematchDetailOpened) {
        const bets = db.getIn(['turboLive', 'detail', 'bets']);
        const matchId = db.getIn(['turboLive', 'detail', 'matchId']);
        const jsBets = bets
            ?.map(bet => bet.toJS())
            .toIndexedSeq()
            .toArray();
        const combinableBets = getCombinablePrematchBets(jsBets, matchId);

        return db.setIn(
            ['turboLive', 'detail', 'combinableBetIdsByMarket'],
            indexOrderedBetsByMarket(combinableBets, 'betOrder', 'betId')
        );
    }
};
